import { useCallback, useEffect, useState } from "react";
import { getMenus } from "../service/menusService";

export function useMenus(idProveedor) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getMenus(idProveedor);
      setData(res || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [idProveedor]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}
